// TSS vite/03 §"Query keys".

export const transferKeys = {
    all:    ['transfer-sessions'],
    list:   (filters) => ['transfer-sessions', 'list', filters],
    detail: (id)      => ['transfer-sessions', 'detail', id],
};
